import { EditOutlined } from '@ant-design/icons';
import Text from 'antd/es/typography/Text';
import { When } from 'react-if';

import React, { useCallback, useEffect, useState } from 'react';
import { useCurrentUser, useUpdateOrganization } from '@hooks';

export interface OrganizationNameInputProps {
	organizationId: number;
	organizationName: string;
}

export const OrganizationNameInput: React.FC<OrganizationNameInputProps> = ({ organizationId, organizationName }) => {
	const [ sentOrganizationNamePatchRequest, setSentOrganizationNamePatchRequest ] = useState(false);
	const [ isEditing, setIsEditing ] = useState(false);

	const { isReadOnly } = useCurrentUser();
	const { isErrored, isFailed, request, reset } = useUpdateOrganization();

	useEffect(() => {
		if (sentOrganizationNamePatchRequest && (isErrored || isFailed)) {
			setSentOrganizationNamePatchRequest(false);
			setIsEditing(false);
			reset();
		}
	}, [ isErrored, isFailed, reset, sentOrganizationNamePatchRequest ]);

	const handleCancel = useCallback(() => {
		setIsEditing(false);
	}, []);

	const handleChange = useCallback(
		(updatedTitle: string) => {
			setIsEditing(false);
			setSentOrganizationNamePatchRequest(true);
			request({
				name: updatedTitle,
				organizationId
			});
		},
		[ organizationId, request ]
	);

	return (
		<div className='organization-title'>
			<Text
				className='title'
				editable={ {
					editing: isEditing,
					icon: <div />,
					onCancel: handleCancel,
					onChange: handleChange,
					tooltip: false
				} }
				ellipsis={ false }>
				{ organizationName }
			</Text>
			<When condition={ !isEditing && !isReadOnly }>
				<EditOutlined
					className='title-edit'
					onClick={ () => {
						setIsEditing(true);
					} } />
			</When>
		</div>
	);
};
